var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternalServerError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.72 145.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#3b5fa8;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:5.41px;}.cls-2{stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "estamostrabajando") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.7,
    y: 132.84,
    width: 12.72,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.65,
    y: 132.84,
    width: 12.72,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.7,
    y: 60.56,
    width: 12.72,
    height: 72.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,23.56a16.93,16.93,0,0,0,.16-2.26,18.6,18.6,0,1,0-37,2.26Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.23,
    y1: 23.56,
    x2: 26.98,
    y2: 23.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.43,
    y: 60.57,
    width: 60.22,
    height: 81.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.65,
    y: 60.57,
    width: 12.72,
    height: 81.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "44.45 23.56 50.77 44.97 44.45 44.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "32.6 60.57 32.6 23.56 58.24 23.56 58.24 60.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.47 30.71 106.68 35.69 111.7 30.93 106.49 25.94 101.47 30.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.94,22.21A7.23,7.23,0,0,0,129,15l-4.42,4.23-4.33-1.11L119,13.94l4.42-4.23a8.06,8.06,0,0,0-7.56,1.93,7.23,7.23,0,0,0-2,7.28l-7.41,7,5.21,5L119,24A8,8,0,0,0,126.94,22.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96,35.92a8,8,0,0,0-7.61,1.92,7.24,7.24,0,0,0-2,7.23l4.42-4.23L95.1,42l1.16,4.15-4.42,4.23A8,8,0,0,0,99.4,48.4a7.23,7.23,0,0,0,1.9-7.61l5.38-5.1-5.21-5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.46 48.88 125.46 44.1 111.7 30.93 106.68 35.69 120.46 48.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.86 13.85 91.36 16.24 88.86 18.63 101.47 30.71 106.49 25.94 93.86 13.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.73 12.67 86.73 11.81 87.63 14.68 89.73 12.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.86 13.85 89.73 12.67 87.63 14.68 88.86 18.63 93.86 13.85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalServerError);
export default __webpack_public_path__ + "static/media/internal-server-error.500e1aea0373f5604dcbd0e3844f4aac.svg";
export { ForwardRef as ReactComponent };